export const sanitizeEstimateInput = (raw = '') =>
  raw
    .toLowerCase()
    .replace(/[^0-9\sчмhm.,]/g, '')
    .replace(/\s+/g, ' ')
    .trimStart()

export const formatEstimateTime = (value) => {
  if (
    /^((\d+)|(\d+\s*[чм])|(\d+\s*[hm])|(\d+\s*ч\s*\d+\s*м)|(\d+\s*h\s*\d+\s*m)|(\d+[.,]\d+))$/.test(
      value
    )
  ) {
    if (value.match(/\d+[.,]\d+/)) {
      const arr = value.split(/[.,]/)
      return `${arr[0]}ч ${Math.round((arr[1] / 10 ** arr[1].toString()?.length) * 60)}м`
    }
    if (value.match(/^\d+$/)) {
      return value + 'ч'
    } else {
      return value
    }
  }

  return ''
}

export const normalizeEstimateDuration = (value) => {
  if (!value) return ''

  const normalized = value.trim().toLowerCase()

  if (!/\d/.test(normalized)) return ''

  if (/^\d+[.,]\d+$/.test(normalized)) {
    const [hours, fraction] = normalized.split(/[.,]/)
    const minutes = Math.round((Number(fraction) / 10 ** fraction.length) * 60)
    return `${hours}ч ${minutes}м`
  }

  if (/^\d+$/.test(normalized)) {
    return `${normalized}ч`
  }

  if (/^\d+\s+\d+$/.test(normalized)) {
    const [hours, minutes] = normalized.split(/\s+/)
    return `${hours}ч ${minutes}м`
  }

  if (/^(\d+)\s*ч\s*(\d+)$/.test(normalized)) {
    const [, hours, minutes] = normalized.match(/^(\d+)\s*ч\s*(\d+)$/)
    return `${hours}ч ${minutes}м`
  }

  if (/^(\d+)\s*h\s*(\d+)$/.test(normalized)) {
    const [, hours, minutes] = normalized.match(/^(\d+)\s*h\s*(\d+)$/)
    return `${hours}h ${minutes}m`
  }

  if (/^\d+\s*[чh]\s*\d+\s*[мm]$/.test(normalized)) {
    return normalized
  }

  if (/^\d+\s*[чh]$/.test(normalized)) {
    return normalized
  }

  if (/^\d+\s*[мm]$/.test(normalized)) {
    return normalized
  }

  return ''
}

export const formatMinutesToDuration = (minutes = 0) => {
  if (minutes === null || minutes === undefined || minutes === '') return ''

  const total = Number(minutes)
  if (!Number.isFinite(total) || total <= 0) return ''

  const h = Math.floor(total / 60)
  const m = Math.round(total % 60)

  if (h > 0 && m > 0) return `${h}ч ${m}м`
  if (h > 0) return `${h}ч`
  return `${m}м`
}
